import { AngularFireAuthGuard, redirectUnauthorizedTo } from '@angular/fire/compat/auth-guard';
import { RouterModule, Routes } from '@angular/router';
import { ScopeGuard } from '@app/shared/guards/scope.guard';
import { AdminScopes } from '@app/shared/services/user.service';
import { NgModule } from '@angular/core';
import { ComponentsModule } from '@app/shared/components/components.module';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/shared/shared.module';
import { AwbLabelsComponent } from '@app/pages/authenticated/pages/awb-labels/awb-labels.component';
import {
  AwbListingComponent
} from '@app/pages/authenticated/pages/awb-labels/components/awb-listing/awb-listing.component';
import {
  ShipmentDetailsComponent
} from '@app/pages/authenticated/components/shipment-details/shipment-details.component';
import {
  UpdateAwbComponent
} from '@app/pages/authenticated/pages/awb-labels/components/update-awb/update-awb.component';

const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(['login']);
const routes: Routes = [
  {
    path: '',
    canActivate: [AngularFireAuthGuard, ScopeGuard],
    data: { scopes: [AdminScopes.VIEW_AWB_LABELS] },
    canActivateChild:[ScopeGuard],
    children: [
      { path: '', component: AwbLabelsComponent, data: { scopes: [AdminScopes.VIEW_AWB_LABELS], authGuardPipe: redirectUnauthorizedToLogin }}
    ]
  }
];

@NgModule({
  imports: [
    ComponentsModule,
    CommonModule,
    RouterModule.forChild(routes),
    SharedModule,
    ShipmentDetailsComponent,
  ],
  exports: [RouterModule],
  declarations: [
    AwbLabelsComponent,
    AwbListingComponent,
    UpdateAwbComponent,
  ]
})
export class AwbLabelsModule { }
